import React from 'react';
import {curry} from 'ramda';
import ErrorIcon from '@material-ui/icons/Error';
import {Genre} from '../../types';

export const getTextWithEmptyFieldError = curry(
    (metadataContentTypeRequiredFields: string[], text: any, fieldLabel: string) => {
        if (
            (!text || !text.length) &&
            metadataContentTypeRequiredFields.includes(fieldLabel)
        ) {
            return (
                <div className="metadata-item__value-error">
                    <div className="metadata-item__value-error_icon">
                        <ErrorIcon />
                    </div>
                    <div>Field can&apos;t be empty</div>
                </div>
            );
        }

        return text;
    }
);

export const handleIsRequiredLabel = curry(
    (metadataContentTypeRequiredFields: string[], fieldLabel: string, label: string) => {
        if (metadataContentTypeRequiredFields.includes(fieldLabel)) {
            return `${label}*`;
        }

        return label;
    }
);

export const getEmptyFieldValidation = curry(
    (metadataContentTypeRequiredFields: string[], fieldLabel: string, value: string) => {
        if (!value && metadataContentTypeRequiredFields.includes(fieldLabel)) {
            return `Field can't be empty`;
        }
    }
);

export const getGenreFieldValidation = curry(
    (
        metadataContentTypeRequiredFields: string[],
        fieldLabel: string,
        genres: Genre[],
        value: string
    ) => {
        const genreObj = genres.find((genre) => genre.label === value);

        if (metadataContentTypeRequiredFields.includes(fieldLabel)) {
            if (!value) {
                return `Field can't be empty`;
            }

            if (!genreObj) {
                return 'Invalid option, select new';
            }
        }
    }
);

export const getSubGenreFieldValidation = curry(
    (
        metadataContentTypeRequiredFields: string[],
        fieldLabel: string,
        genres: Genre[],
        genreValue: any,
        value: string
    ) => {
        const genreObj = genres.find((genre) => genre.label === genreValue);
        const subGenre = genreObj?.subGenres?.find(
            (subGenre) => subGenre.label === value
        );

        if (
            metadataContentTypeRequiredFields.includes(fieldLabel) &&
            (!value || !subGenre)
        ) {
            return `Field can't be empty`;
        }
    }
);

export const getAllotmentFieldValidation = (value: number | null) => {
    if (!value && typeof value !== 'number') {
        return `Field can't be empty`;
    }
};
